import type { MouseEvent } from 'react'

const digits = (s: string) => s.replace(/[^0-9]/g, '')

/** An Instagram handle as typed on the form ("@name", "instagram.com/name", "name ") → "name", or '' when it is not one. */
export const igHandle = (v: string) => {
  const h = (v || '').trim().replace(/^https?:\/\/(www\.)?instagram\.com\//i, '').replace(/^@/, '').split(/[/?#\s]/)[0]
  return /^[A-Za-z0-9._]{1,30}$/.test(h) ? h : ''
}
const waNumber = (phone: string) => { const d = digits(phone); return d.length === 10 ? '1' + d : d }

/** Reach the person the way they asked first (black), the rest beside it (grey). Text and WhatsApp open with the message
 *  written; Instagram cannot take a written message from a link, so it is copied first and pasted in the chat. */
export function ContactButtons({ name, phone, email, instagram, pref, subject, body, toast }: { name: string; phone: string; email: string; instagram: string; pref?: string; subject: string; body: string; toast: (m: string, o?: { kind?: 'ok' | 'bad' }) => void }) {
  const ig = igHandle(instagram)
  const opts: { key: string; label: string; href: string; copy?: boolean }[] = []
  if (phone) opts.push({ key: 'text', label: 'Text', href: `sms:${digits(phone)}&body=${encodeURIComponent(body)}` })
  if (ig) opts.push({ key: 'instagram', label: 'Instagram', href: `https://ig.me/m/${ig}`, copy: true })
  if (phone) opts.push({ key: 'whatsapp', label: 'WhatsApp', href: `https://wa.me/${waNumber(phone)}?text=${encodeURIComponent(body)}` })
  if (email) opts.push({ key: 'email', label: 'Email', href: `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}` })
  const first = opts.find((o) => o.key === pref) ?? opts[0]
  const list = first ? [first, ...opts.filter((o) => o !== first)] : []
  const copyThen = (e: MouseEvent) => {
    try { void navigator.clipboard?.writeText(body) } catch { /* no clipboard: the chat still opens */ }
    toast(`Message copied. Paste it in the chat with ${name.split(' ')[0] || 'them'}.`, { kind: 'ok' })
    void e
  }
  return (
    <div style={{ display: 'flex', gap: 8, padding: '4px 20px 8px', flexWrap: 'wrap' }}>
      {list.map((o) => (
        <a key={o.key} className="cta cta--center" style={{ flex: 1, minWidth: 90, textDecoration: 'none', ...(o === first ? {} : { background: '#e5e5ea', color: '#000' }) }}
          href={o.href} target={o.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer" onClick={o.copy ? copyThen : undefined}>
          {o.label}{o === first && pref === o.key ? ' · preferred' : ''}
        </a>
      ))}
    </div>
  )
}

